var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachmentBulletsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8V6H18V8H16ZM16 10V8H14V10H16ZM16 6V4H14V6H16ZM14 0.84V2H16C15.37 1.54 14.71 1.15 14 0.84ZM16 2V4H18C17.42 3.25 16.75 2.58 16 2ZM18 4V6H19.16C18.85 5.29 18.46 4.63 18 4ZM20 10C20 9.32 19.93 8.65 19.8 8H18V10H20ZM14 4V2H12V4H14ZM14 14H16V12H14V14ZM16 16H18V14H16V16ZM14 18H16V16H14V18ZM12 19.8C12.7 19.66 13.36 19.44 14 19.16V18H12V19.8ZM16 12H18V10H16V12ZM14 6H12V8H14V6ZM18 14H19.16C19.44 13.36 19.66 12.7 19.8 12H18V14ZM14 10H12V12H14V10ZM10 16V14H12V12H10V10H12V8H10V6H12V4H10V2H12V0.2C11.35 0.0700001 10.69 0 10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20V18H12V16H10ZM12 16H14V14H12V16Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentBulletsIcon);
export default __webpack_public_path__ + "static/media/Attachment_bullets_icon.6adb6cc25f1010933f361eb80eb39a9f.svg";
export { ForwardRef as ReactComponent };